import { GridOptions } from '@ag-grid-community/core';

import { AgRawTooltip } from '@shared/components/ag-raw-tooltip/ag-raw-tooltip';
import { TableConstants } from '@shared/constants/table.constants';

export const SITE_COST_SUMMARY_TABLE_DEFAULT_CONFIG: GridOptions = {
  ...TableConstants.DEFAULT_GRID_OPTIONS.GRID_OPTIONS,
  defaultColDef: {
    ...TableConstants.DEFAULT_GRID_OPTIONS.DEFAULT_COL_DEF,
    headerClass: [TableConstants.STYLE_CLASSES.HEADER_ALIGN_CENTER, 'text-center', 'text-wrap'],
    resizable: true,
    tooltipComponent: AgRawTooltip,
    tooltipValueGetter: (params) => params.valueFormatted,
  },
  // Fix unexpected separation of columns
  processUnpinnedColumns: () => [],
};
